export default __webpack_public_path__ + "static/media/match.76cedfa4.svg";